module.exports = __webpack_public_path__ + "static/media/logo.bc21f560.png";